import React, { useState } from 'react'

import Button from '../../../../../../components/molecules/Button/Button';

import { ProhibitedItem } from '../../../../../user/components/SearchPickUser/SearchSelectUserPresenter';
import SearchUserMemberModal from '../../../../../user/components/SearchUserMemberModal';
import { IUser } from '../../../../../auth/types/user.types';

export interface AddManagerBtnProps {
  setManager: (manager: IUser[]) => void;
  label?: string;
  titleModal?: string;
  employeeProhibitedList?: ProhibitedItem[];
  currentMembersList?: Partial<IUser>[];

 }
export default function AddManagerBtn({setManager,currentMembersList, label = 'Ajouter un manager', titleModal='Ajouter un manager', employeeProhibitedList} : AddManagerBtnProps) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
 

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen &&
        <SearchUserMemberModal titleModal={titleModal} currentMembersList={currentMembersList as IUser[]} setNewMemberList={setManager} onClose={handleModalClose}  employeeProhibitedList={employeeProhibitedList} />
      }
      <Button onClick={() => {handleModalOpen()}} maxWidth="180px" label={label} style="black" />{/* eslint-disable-line */}
    </>
  )
}
